/* Plasmik3D — Délai de fabrication, côté panier
   ==================================================================
   Pilote les surfaces de délai qui dépendent du contenu du panier :

   - l'avis au-dessus de la liste d'articles (ses deux états),
   - la case d'acquittement avant paiement (page panier et tiroir),
   - le blocage du paiement, y compris depuis la notification d'ajout.

   Le panier est lu depuis /cart.js plutôt que depuis le HTML rendu. Dawn ne
   re-rend que main-cart-items, cart-icon-bubble, cart-live-region-text et
   main-cart-footer lors d'une mise à jour : tout état calculé au rendu serveur
   pour une autre zone resterait figé.

   Deux responsabilités distinctes, et la distinction compte :

   - refresh() relit le panier par le réseau. Déclenché par les événements
     panier de Dawn (PUB_SUB_EVENTS.cartUpdate).
   - render() applique l'état courant au DOM, sans réseau. Déclenché AUSSI
     quand Dawn réécrit une zone panier, parce que le HTML neuf arrive sans nos
     attributs. C'est ce qui manquait : la notification d'ajout est réinjectée
     après notre passage, son bouton de paiement repartait donc actif.
   ================================================================== */
(function () {
  'use strict';

  var configElement = document.querySelector('[data-delay-config]');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent) || {};
  } catch (e) {
    return;
  }

  var exemptProductIds = config.exemptProductIds || [];
  var ackRequired = config.ackRequired === true;
  var orderLabel = config.orderLabel || 'Délai accepté';
  var delayValue = config.delayValue || '';

  var state = { empty: true, affected: false, acknowledgedInCart: false };
  var persisting = false;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function checkboxes() {
    return document.querySelectorAll('[data-delay-ack-check]');
  }

  /* Une zone panier est-elle présente sur cette page ? Sert à distinguer deux
     situations que confondre coûte cher : une zone panier SANS case à cocher est
     une erreur de gabarit, alors qu'une page sans zone panier du tout (une fiche
     produit, avec sa notification d'ajout) est parfaitement normale. */
  function cartSurfaceExists() {
    return !!document.querySelector('.cart__footer, cart-drawer, #CartDrawer, #main-cart-footer');
  }

  function isAcknowledged() {
    if (!ackRequired) return true;

    var boxes = checkboxes();
    if (boxes.length) {
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].checked) return true;
      }
      return false;
    }

    /* Zone panier présente mais aucune case : erreur de gabarit. On laisse
       passer — verrouiller la boutique coûterait plus cher qu'un acquittement
       manqué, et le client n'aurait aucun moyen de se débloquer. */
    if (cartSurfaceExists()) return true;

    /* Hors du panier — typiquement la notification d'ajout sur une fiche
       produit. Aucune case n'y est rendue, on se fie donc à l'acquittement
       enregistré dans le panier. C'est ce qui empêche la notification d'offrir
       un paiement direct qui contournerait la case. */
    return state.acknowledgedInCart;
  }

  function readCart() {
    return fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var affected = false;
        if (cart && cart.items) {
          cart.items.forEach(function (item) {
            if (exemptProductIds.indexOf(item.product_id) === -1) affected = true;
          });
        }
        state.empty = !cart || !cart.item_count;
        state.affected = affected;
        state.acknowledgedInCart = !!(cart && cart.attributes && cart.attributes[orderLabel]);
      })
      .catch(function () {
        /* Panier illisible : on n'affiche rien plutôt que de bloquer à tort. */
        state.affected = false;
      });
  }

  /* L'acquittement vit dans le panier, il survit donc au rechargement et aux
     allers-retours entre la page panier et le tiroir. */
  function restoreFromCart() {
    if (!state.acknowledgedInCart) return;
    checkboxes().forEach(function (box) {
      box.checked = true;
    });
  }

  function persist(acknowledged) {
    persisting = true;
    var attributes = {};
    var stamp = new Date().toLocaleDateString('fr-FR');
    attributes[orderLabel] = acknowledged ? delayValue + ' — accepté le ' + stamp : '';

    return fetch(routeRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    })
      .catch(function () {
        /* L'échec d'écriture ne doit pas bloquer le client : la case reste
           cochée côté navigateur, seule la trace dans la commande est perdue. */
      })
      .then(function () {
        persisting = false;
      });
  }

  function toggle(element, visible) {
    if (!element) return;
    if (visible) element.removeAttribute('hidden');
    else element.setAttribute('hidden', '');
  }

  /* Les deux états de l'avis sont rendus côté serveur ; on choisit lequel est
     visible. C'est ce qui le fait suivre une suppression d'article, alors que
     sa section n'est pas re-rendue par Dawn. */
  function renderNotice() {
    document.querySelectorAll('[data-delay-notice]').forEach(function (wrapper) {
      toggle(wrapper.querySelector('[data-delay-notice-state="affected"]'), !state.empty && state.affected);
      toggle(wrapper.querySelector('[data-delay-notice-state="exempt"]'), !state.empty && !state.affected);
    });
  }

  function renderAcknowledgment(locked) {
    var wanted = !state.empty && state.affected;

    document.querySelectorAll('[data-delay-ack]').forEach(function (block) {
      toggle(block, wanted);
    });

    document.querySelectorAll('.cart__footer, cart-drawer, #CartDrawer').forEach(function (region) {
      region.classList.toggle('delay-ack-locked', locked);
    });

    document.querySelectorAll('button[name="checkout"], #checkout').forEach(function (button) {
      if (locked) {
        /* Marqué pour ne réactiver que ce qu'on a désactivé : un bouton déjà
           désactivé pour panier vide doit le rester. */
        if (!button.disabled) {
          button.disabled = true;
          button.dataset.delayLocked = 'true';
        }
      } else if (button.dataset.delayLocked === 'true') {
        button.disabled = false;
        delete button.dataset.delayLocked;
      }
    });

    /* La notification d'ajout propose un paiement direct sans passer par le
       panier : elle contournerait l'acquittement, qui n'y est pas rendu. On
       retire ce raccourci tant que le panier n'est pas acquitté — son lien
       « voir mon panier » subsiste, et c'est là que le client acquitte. */
    var notificationForm = document.getElementById('cart-notification-form');
    if (notificationForm) notificationForm.hidden = locked;
  }

  function render() {
    var locked = !state.empty && state.affected && !isAcknowledged();
    renderNotice();
    renderAcknowledgment(locked);
  }

  function flag() {
    var visible = document.querySelectorAll('[data-delay-ack]:not([hidden])');
    for (var i = 0; i < visible.length; i++) {
      if (!visible[i].getClientRects().length) continue;
      visible[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
      var box = visible[i].querySelector('[data-delay-ack-box]');
      if (box) {
        box.classList.add('delay-ack--flagged');
        window.setTimeout(function () {
          box.classList.remove('delay-ack--flagged');
        }, 1400);
      }
      var checkbox = visible[i].querySelector('[data-delay-ack-check]');
      if (checkbox) checkbox.focus({ preventScroll: true });
      return;
    }
  }

  var CHECKOUT_CONTROLS = 'button[name="checkout"], #checkout, .cart__checkout-button';

  /* Filet de sécurité : le bouton désactivé suffit en général, mais les
     paiements accélérés et les soumissions clavier peuvent contourner l'état
     visuel. On intercepte donc en phase de capture.

     Cette écoute est large, donc elle doit viser juste. Une version précédente
     testait « l'action du formulaire contient /cart », ce qui attrapait aussi
     /cart/add : comme la capture précède product-form.js et coupe la
     propagation, le bouton « Ajouter au panier » ne faisait plus rien du tout.
     On ne déduit donc plus l'intention de l'URL, mais du bouton déclencheur. */
  function guard(event) {
    if (state.empty || !state.affected || isAcknowledged()) return;

    var hit = null;

    if (event.type === 'click') {
      var target = event.target;
      if (target && target.closest) hit = target.closest(CHECKOUT_CONTROLS);
    } else {
      var submitter = event.submitter;
      if (submitter && submitter.closest) {
        hit = submitter.closest(CHECKOUT_CONTROLS);
      } else if (event.target && event.target.getAttribute) {
        /* Navigateur sans event.submitter : on n'accepte que le formulaire du
           panier lui-même. L'ancre de fin exclut /cart/add tout en acceptant
           les routes localisées comme /fr/cart. */
        var action = (event.target.getAttribute('action') || '').split('?')[0].replace(/\/+$/, '');
        if (/\/cart$/.test(action) && event.target.querySelector(CHECKOUT_CONTROLS)) {
          hit = event.target;
        }
      }
    }

    if (!hit) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    flag();
  }

  function bind() {
    checkboxes().forEach(function (box) {
      if (box.dataset.delayBound === 'true') return;
      box.dataset.delayBound = 'true';
      box.addEventListener('change', function () {
        render();
        persist(box.checked);
      });
    });
  }

  function refresh() {
    if (persisting) return Promise.resolve();
    return readCart().then(function () {
      bind();
      restoreFromCart();
      render();
    });
  }

  /* Dawn remplace le HTML des zones panier sans prévenir, et le contenu neuf
     arrive sans nos attributs. On réapplique alors l'état SANS appel réseau, et
     on se limite aux conteneurs concernés plutôt que d'observer tout le
     document comme le faisait la version précédente. */
  function watchCartRegions() {
    var timer;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        bind();
        render();
      }, 60);
    });

    ['#cart-notification', '#CartDrawer', 'cart-drawer', '#main-cart-footer', '#main-cart-items'].forEach(
      function (selector) {
        document.querySelectorAll(selector).forEach(function (region) {
          observer.observe(region, { childList: true, subtree: true });
        });
      }
    );
  }

  function init() {
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);
    refresh();
    watchCartRegions();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
